import { Skeleton } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { CardUiParams } from "./DashboardCard"

const useStyles = makeStyles()((theme) => ({
    skeleton: {
        width: CardUiParams.WIDTH,
        borderRadius: CardUiParams.BORDER_RADIUS,
        [theme.breakpoints.down("xl")]: {
            width: CardUiParams.WIDTH_SM,
        },
    },
    normal: {
        height: CardUiParams.HEIGHT,
    },
    small: {
        height: "9.375rem",
    },
    skeletonFullSize: {
        width: "100%",
        height: "100%",
        minHeight: "8rem",
    },
}))
type DashboardCardSkeletonType = Readonly<{
    count?: number
    isSmall?: boolean
}>

export function DashboardCardSkeleton({ count = 1, isSmall = false }: DashboardCardSkeletonType) {
    const { classes, cx } = useStyles()
    return (
        <>
            {Array.from({ length: count }, (_, index) => (
                <Skeleton
                    key={index}
                    variant="rectangular"
                    animation="wave"
                    className={cx(classes.skeleton, isSmall ? classes.small : classes.normal)}
                />
            ))}
        </>
    )
}

export function DashboardCardFullSizeSkeleton() {
    const { classes } = useStyles()
    return <Skeleton variant="rectangular" animation="wave" className={classes.skeletonFullSize} />
}
